// extracted by mini-css-extract-plugin
export default {"shippingStatusContainer":"MD-z","shipmentMessage":"ND-z","shipmentNumber":"OD-z","trackingProgressContainer":"PD-z"};